import Dexie from 'dexie'
import { log } from '@/services/log'
import { generateStoreName } from '@/services/store-utils'

const IDENTITY = 'DexiePlugin'

export function createDexie(appStoreFn, allIdbEntities) {
  log('Inside createDexie function with server entities', allIdbEntities)
  return {
    install(app) {
      log('Inside', IDENTITY)
      const versionedName = generateStoreName()

      log(`Inside ${IDENTITY} - using store name ${versionedName}`)

      const db = new Dexie(versionedName)
      const schema = {}
      allIdbEntities.forEach((d) => {
        schema[d.objectStoreName] = `${d.keyPath}, ${d.indexes.join(', ')}`
      })
      schema.ReaderLiveViewRequests = '++, *readers, requestUuid, *tagPrefixes, *antennaPorts, startTime, userName'
      schema.ReaderLiveViewResults =
        '++, readerNetworkAddress, readzoneAlias, tag, antennaPort, first, last, count, uuid'
      schema.ApplicationLogs = '++id, username, timestamp, logArgs'
      schema.remoteErrors = '++id, message, username, logLevel, data, offendingMethod, cause, culpritClass, pending'
      schema.uploadDataResults = '++id,uploadId, messageJson, rowNum,rowStatus'
      schema.uploadData =
        '++id,createdTimestamp, availableCount,processedCount,successCount,failureCount,partialCount,rejectedCount,startTimestamp,finishTimestamp,username,uploadStatus,rows,parsedRows,uploadType,file, busy, fields,message, uri'
      schema.userActivity = '&externalId, moduleName, activityName, dirty, pending, [dirty+pending]'
      db.version(1).stores(schema)
      db.open()
      app.provide('dexie', db)
    },
  }
}
